import { useSelector } from "react-redux";
import { ApplicationState } from "..";

export const useCompanyManufacturerReducer = () => useSelector((state: ApplicationState) => state.companyManufacturer);
